
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uk/faq",
      function () {
        return require("private-next-pages/uk/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uk/faq"])
      });
    }
  